import React, { Component, Fragment } from "react";
import { inject, observer } from 'mobx-react';
import classnames from "classnames";
import { Button, FormGroup, Input, Label, Table, Modal, ModalBody, ModalFooter } from "reactstrap";
import { Plus, Edit, Search, Trash } from "react-feather";

@inject('configurationStore')
@observer
class Configuration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      configOverlayVisible: false,
      isEditable: false
    };
  }

  componentDidMount = () => {
    const { configurationStore } = this.props;
    configurationStore.getConfigurations();
  }

  onChange = event => {
    const { configurationStore } = this.props;
    let value = event.target.value;
    if (event.target.name === "name" || "configCode" || "value") {
      configurationStore.setAttribute(event.target.name, value);
    }
  };


  handleSave = () => {
    const { configurationStore } = this.props;
    configurationStore.saveConfiguration();
    this.toggleOverlay(false);
  }

  // toogle method will take 3 params -> toggle: bool, new/edit: string, data: any
  toggleOverlay = (toggle, action = "", data = false) => {
    const { configurationStore } = this.props;
    if (toggle) {
      if (action === "new") {
        configurationStore.setBlankConfiguration();
      }
      if (action === "edit" && data) {
        configurationStore.setConfiguration(data);
      }
    }
    this.setState({
      isEditable: action === "edit" ? true : false,
      configOverlayVisible: toggle
    });
  }

  remove = (uid) => {
    this.setState({
      deleteModal: true,
      currentEntryId: uid
    })
  }

  deleteEntry = () => {
    //Delete Call
    this.setState({
      deleteModal: false
    })
  }


  render() {
    const { configurationStore } = this.props;
    const { configurations } = configurationStore;
    const { name, value, configCode, lastUpdatedOn } = configurationStore.configuration;
    return (
      <Fragment>
        <div className="topbar">
          <FormGroup className="position-relative mb-0" style={{ width: "30%" }}>
            <Input
              className="w-100 mr-1 mb-sm-0 search-product"
              type="text"
              placeholder="search..."
              value={this.state.searchVal}
            />
            <div className="form-control-position">
              <Search size={22} />
            </div>
          </FormGroup>
          <Button
            color="primary"
            className="btn"
            onClick={() => this.toggleOverlay(true, "new")}
          >
            <Plus size={18} />Add New
          </Button>
        </div>
        <div>
          {
            configurations && configurations.length
              ? <Table hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Value</th>
                    <th>Last Updated</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    configurations.map((item, index) => {
                      return (
                        <Fragment>
                          {
                            item.visible
                              ? <tr key={item.uid}>
                                <td>{item.name}</td>
                                <td>{item.value}</td>
                                <td>{item.lastUpdatedOn}</td>
                                <td className="text-center">
                                  {
                                    item.editable
                                      ? <Edit size={16} className="mr-1" onClick={() => this.toggleOverlay(true, 'edit', item)} />
                                      : null 
                                  }
                                  {
                                    item.deletable
                                      ? <Trash size={16} color="#dc3545" onClick={() => this.remove(item.uid)} />
                                      : null
                                  }
                                </td>
                              </tr>
                              : null
                          }
                        </Fragment>
                      );
                    })
                  }
                </tbody>
              </Table>
              : null
          }

        </div>
        <div className="animation-slider">
          {
            this.state.configOverlayVisible
              ? <Fragment>
                <div className="animation-slider-sidebar" style={{ width: "40vw" }}>
                  <div className="sidebar_header">
                    <span className="heading">
                      Save
                    </span>
                    <div>
                      <Button
                        className="btn mr-1"
                        onClick={this.handleSave}
                        color="primary">
                        {this.state.isEditable ? "Update" : "Add"}
                      </Button>
                      <Button
                        className="btn ml-1"
                        outline
                        color="danger"
                        onClick={() => this.toggleOverlay(false)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                  <div className="sidebar_content">
                    <FormGroup>
                      <Label htmlFor="category_name">Category Name</Label>
                      <Input
                        type="text"
                        value={name}
                        name="name"
                        placeholder="Category Name"
                        onChange={e => this.onChange(e)}
                        id="category_name"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="config_code">Configuration Code</Label>
                      <Input
                        type="text"
                        value={configCode}
                        disabled={this.state.isEditable ? true : false}
                        name="configCode"
                        placeholder="Configuration Code"
                        onChange={e => this.onChange(e)}
                        id="config_code"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="display_order">Value</Label>
                      <Input
                        type="text"
                        value={value}
                        name="value"
                        placeholder="Value"
                        onChange={e => this.onChange(e)}
                        id="display_order"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div
                  className={classnames("animation-slider-overlay", {
                    show: this.state.configOverlayVisible
                  })}
                  onClick={() => this.toggleOverlay(false)}
                />
              </Fragment>
              : null
          }
        </div>

        <div>
          <Modal isOpen={this.state.deleteModal}>
            <ModalBody>
              <h4>Are you sure you want to delete this Configuration.</h4>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => { this.setState({ deleteModal: false }) }}>Cancel</Button>{' '}
              <Button color="primary" onClick={this.deleteEntry}>Delete</Button>
            </ModalFooter>
          </Modal>
        </div>

      </Fragment>
    );
  }
}

export default Configuration;